import React from "react";
import KioskLayout from "components/Layout/KioskLayout";
import EventDetail from "components/Kiosk/Event/EventDetail";
import MapRouterMaster from "containers/MapRouterMaster";
import useDestination from "hooks/useDestination";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import { mainApiPath } from "api/constants";
import { mapRouterType , screenKeys, gaSettings } from "config/constants";

const KioskEventDetail = (props) => {
  const [error, loading, eventDetail] = useFetch(
    mainApiPath.event  + '/' + props.match.params.id
  );

  const destination = useDestination(props.location.search);

  const gaTitle = gaSettings.eventDirect.title;
  const gaLocation = eventDetail?.title
    ? gaSettings.eventDirect.location + eventDetail.title
    : null;
  useGaPageView({ gaTitle, gaLocation });

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk + '/' +  screenKeys.event}
      left={
        <MapRouterMaster
          type={mapRouterType.pathGuide}
          slotInfo={destination}
          destinationName={eventDetail ? eventDetail.destination_name : ''}
          layout={'kiosk'}
        />
      }
      right={
        <EventDetail
          details={eventDetail ? eventDetail : null}
          loading={loading}
        />
      }
    />
  );
};

export default KioskEventDetail;
